export default __webpack_public_path__ + "static/media/calibri.29c57b05.ttf";